import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { firebaseConfig } from '../.env'

export class Firestore {
  static app = initializeApp(firebaseConfig)
  static getDb () {
    return getFirestore(this.app)
  }
}
